import {
  AutovioCalendarEvent,
  isASFCourseSession,
  isPaidLesson,
  isTheoryExam,
  isTheoryLesson,
} from "./autovioCalendarEvents";

export class StudentAttendanceLogic {
  static booked(event: AutovioCalendarEvent, studentId: string): boolean {
    if (isTheoryLesson(event)) {
      return event.students[studentId]?.rsvp === "accepted";
    } else if (isASFCourseSession(event)) {
      return event.participants[studentId]?.rsvp === "accepted";
    } else if (isPaidLesson(event) || isTheoryExam(event)) {
      return ["accepted", "canceled", "no-show"].includes(event.student.rsvp);
    } else {
      throw new Error(`Unexpected event type: ${event.type}`);
    }
  }

  static attended(event: AutovioCalendarEvent, studentId: string): boolean {
    if (isTheoryLesson(event)) {
      const attendance = event.students[studentId];
      return attendance.attended ?? false;
    } else if (isASFCourseSession(event)) {
      const attendance = event.participants[studentId];
      return attendance.attended ?? false;
    } else if (isPaidLesson(event)) {
      return event.student.rsvp === "accepted" && !!event.endedAt;
    } else if (isTheoryExam(event)) {
      return !!event.theoryExamResult || Object.keys(event.theoryExamResults ?? {}).length > 0;
    } else {
      throw new Error(`Unexpected event type: ${event.type}`);
    }
  }

  static canceledOrNoShow(event: AutovioCalendarEvent, studentId: string): boolean {
    if (isTheoryLesson(event)) {
      const attendance = event.students[studentId];
      return attendance.rsvp === "rejected" || (attendance.noShow ?? false);
    } else if (isASFCourseSession(event)) {
      const attendance = event.participants[studentId];
      return attendance.rsvp === "rejected" || (attendance.noShow ?? false);
    } else if (isPaidLesson(event) || isTheoryExam(event)) {
      return event.student.rsvp === "no-show" || !!event.student.canceledAtShortNotice;
    } else {
      throw new Error(`Unexpected event type: ${event.type}`);
    }
  }
}
